import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getRfqStatusCounts } from "../../../../api/client";
import { queryKeys } from "../../../../api/queryKeys";

const NO_COUNTS = { NEW: 0, DIY: 0, QUOTED: 0 };

/** RFQs per tab for the user (a lightweight query, no items); zeros on failure. */
export function useRfqCounts(userName: string | undefined) {
  const { data: countsData } = useQuery({
    queryKey: queryKeys.rfqCounts.forUser(userName),
    queryFn: async () => {
      try {
        return await getRfqStatusCounts(userName || '');
      } catch (err) {
        console.error('Error fetching counts:', err);
        return { NEW: 0, DIY: 0, QUOTED: 0 };
      }
    },
    staleTime: 30000, // 30 seconds - counts don't need to be as fresh
    gcTime: 300000 // 5 minutes
  });

  return useMemo(() => countsData || NO_COUNTS, [countsData]);
}
